'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { getDefaultCategories } from '@libs/algolia';
import { PageType, useFeaturedBrand, usePageLayout, useSearchPage } from '@libs/common-next';
import { getCustomerObject, getPageData, getProductObject } from '../../helpers/digitalData';
import type { DigitalDataObject, DigitalDataProps } from './types';
declare const window: Window & typeof globalThis & {
  digitalData: DigitalDataObject;
};
export function DigitalData(t0) {
  const $ = _c(7);
  const {
    product,
    categories
  } = t0;
  const {
    pageType: appPageType,
    user,
    userData
  } = usePageLayout();
  const isFeaturedBrand = useFeaturedBrand();
  const isSearchPage = useSearchPage();
  const searchPageType = isFeaturedBrand ? "Brand Landing Page" : categories?.length && !isSearchPage ? "Category Landing" : "Product List";
  const currentPageType = appPageType === PageType.PLP ? searchPageType : "Product Details";
  let t1;
  let t2;
  if ($[0] !== categories || $[1] !== currentPageType || $[2] !== product || $[3] !== user || $[4] !== userData) {
    t1 = () => {
      const productCategories = product ? getDefaultCategories(product).map(_temp) : [];
      const productData = product ? getProductObject(product, productCategories) : {};
      const customerData = getCustomerObject(user, userData);
      const pageData = getPageData(categories ?? productCategories, currentPageType);
      window.digitalData = {
        ...window.digitalData,
        ...customerData,
        ...pageData,
        ...productData
      };
    };
    t2 = [product, categories, currentPageType, user, userData];
    $[0] = categories;
    $[1] = currentPageType;
    $[2] = product;
    $[3] = user;
    $[4] = userData;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  return "";
}
function _temp(cat) {
  return cat.name.default;
}